import { authHeader, BASE_URL, handleResponse, handleResponseBlob } from '@helpers/api';

export const feedbacksService = {
    getAll,
    addOrUpdateTicket,
    checkNewExist,
    exportCSV,
};

function getAll(params, pageToken = null, pageSize = 25) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(params),
    };
    const nextPageToken = pageToken ? `&pageToken=${pageToken}` : '';
    return fetch(`${BASE_URL}api/survey-responses/query?${nextPageToken}&pageSize=${pageSize}`, requestOptions).then(
        handleResponse,
    );
}

function checkNewExist(query) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(query),
    };
    return fetch(`${BASE_URL}api/survey-responses/new`, requestOptions).then(handleResponse);
}

function addOrUpdateTicket(ticket, reviewId) {
    const requestOptions = {
        method: 'PUT',
        headers: authHeader(),
        body: JSON.stringify(ticket),
    };

    return fetch(`${BASE_URL}api/survey-responses/${reviewId}/tickets`, requestOptions).then(handleResponse);
}

function exportCSV(query) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(query),
    };
    return fetch(`${BASE_URL}api/export/feedbacks`, requestOptions).then(handleResponseBlob);
}
